import { useAppContext } from "../contexts/AppContext";

const useRiskScore = (onScoreChange) => {
  const { riskScores, setRiskScores } = useAppContext();

  const calculateOverallScore = () => {
    // Récupérer toutes les valeurs de score
    const totalScores = Object.values(riskScores).flatMap((category) =>
      Object.values(category)
    );
    // Calculer la moyenne uniquement sur les scores non nuls
    const validScores = totalScores.filter((score) => score > 0);
    const total = validScores.reduce((sum, score) => sum + score, 0);
    const count = validScores.length;
    return count > 0 ? (total / count).toFixed(2) : 0;
  };

  const handleScoreChange = (category, field, value) => {
    const updatedScores = {
      ...riskScores,
      [category]: {
        ...riskScores[category],
        [field]: Number(value),
      },
    };
    setRiskScores(updatedScores);
  };

  const overallScore = calculateOverallScore();


  const getScoreColor = (score) => {
    if (score >= 1 && score <= 1.99) {
      return "green"; // Vert
    } else if (score >= 2 && score <= 3.99) {
      return "orange"; // Orange
    } else {
      return "red"; // Rouge
    }
  };

  

  return {
    handleScoreChange,
    overallScore,
    getScoreColor
  };
};

export default useRiskScore;

